module.exports = __webpack_public_path__ + "static/bag-490a2bafad3103db295ec3f14a9744cf.png";